"use client";

import React, { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import ButtonThird from "@/shared/ButtonThird";
import ButtonPrimary from "@/shared/ButtonPrimary";
import { useAppDispatch, useAppSelector } from "@/app/lib/hooks";
import { setFilter } from "@/app/lib/reducers/toursReducer";
import { useTranslation } from 'react-i18next';

const PricePerPeopleFilter: React.FC = () => {
  const dispatch = useAppDispatch();
  const people = useAppSelector((state) => state.tours.filters.people);
  const { t } = useTranslation("guydeez");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (/^\d*$/.test(e.target.value)) {
      dispatch(setFilter("people", Number(e.target.value)));
    }
  };

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border ${
              open ? "!border-primary-500" : "border-neutral-300 dark:border-neutral-700"
            } hover:border-neutral-400 dark:hover:border-neutral-600 focus:outline-none`}
          >
            <span>{t('filter_show_price', {people:people} )}</span>
            <i className="las la-angle-down ml-2" />
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-50 w-screen max-w-sm px-4 mt-3 sm:px-0 lg:max-w-md">
              <div className="rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border dark:border-neutral-700">
                <div className="flex flex-col px-5 py-6 space-y-5">
                  <label htmlFor="pricePerPerson" className="text-sm font-medium">
                    {t('filter_enter_number_people')}
                  </label>
                  <input
                    type="text"
                    id="pricePerPerson"
                    value={people}
                    onChange={handleChange}
                    className="block w-full rounded-full border-neutral-200 text-neutral-900 pl-3 pr-3 sm:text-sm"
                    placeholder="Enter a number"
                  />
                </div>
                <div className="p-5 bg-neutral-50 dark:bg-neutral-900 border-t dark:border-neutral-800 flex justify-between">
                  <ButtonThird onClick={close}>{t('filter_clear')}</ButtonThird>
                  <ButtonPrimary onClick={close}>{t('filter_apply')}</ButtonPrimary>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default PricePerPeopleFilter;
